/* eslint-disable @typescript-eslint/ban-ts-comment */

import React, { useEffect, useMemo, useState } from 'react'
import AdminHeader from 'live/components/header/ui/admin/header'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import { Tabs, Tab } from 'react-bootstrap'
import ThumbnailList from './thumbnails/ThumbnailList'
import OrphanList from './orphans/OrphanList'
import Pagination from './orphans/Pagination'

const AdnocAdminPage: React.FC = () => {
    const [dashboards, setDashboards] = useState<string[]>()
    const [orphans, setOrphans] = useState<Orphans>()
    const [page, setPage] = useState(1)
    const [searchTerm, setSearchTerm] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const limit = 10

    const fetchOrphans = (pageNumber: number, search: string): void => {
        setIsLoading(true)
        const url = `services/plugin-asset-metadata/orphans/get?page=${pageNumber - 1}&limit=${limit}&filter=${search}`

        fetch(url)
            .then(result => {
                if (result.ok) {
                    return result.json()
                } else {
                    throw new Error()
                }
            })

            .then(items => {
                setOrphans(items)
                setIsLoading(false)
            })
            .catch(e => {
                globalNotification.error(e.message ?? i18n('An error occurred while fetching orphans'))
            })
    }

    useEffect(() => {
        const urlDashboards = 'services/plugin-asset-metadata/thumbnail/dashboardList'

        fetch(urlDashboards)
            .then(result => {
                if (result.ok) {
                    return result.json()
                } else {
                    throw new Error()
                }
            })

            .then(items => setDashboards(items))
            .catch(e => globalNotification.error(e.message ?? i18n('An error occurred while fetching dashboards')))
    }, [])

    useEffect(() => {
        fetchOrphans(page, searchTerm)
    }, [page, searchTerm])

    return useMemo(() => {
        return (
            <Container className="admin-content">
                <div className="admin-inner">
                    <AdminHeader>
                        <h2>{i18n('Asset Metadata Settings')}</h2>
                    </AdminHeader>
                    <Body>
                        <br />
                        <Tabs className="has-paddings" defaultActiveKey="dashboard-thumbnails">
                            <Tab eventKey="dashboard-thumbnails" title={i18n('Dashboard Thumbnails')}>
                                {dashboards && <ThumbnailList dashboardNames={dashboards} />}
                            </Tab>
                            <Tab eventKey="orphan-assets" title="Orphan Assets">
                                {isLoading ? (
                                    <Loading>Loading...</Loading>
                                ) : orphans ? (
                                    <>
                                        <input
                                            type="text"
                                            value={searchTerm}
                                            onChange={e => setSearchTerm(e.target.value)}
                                            placeholder="Search..."
                                        />
                                        <OrphanList orphans={orphans.data} fetchOrphans={fetchOrphans} />
                                        <br />
                                        <Pagination
                                            page={page}
                                            setPage={setPage}
                                            total={orphans.total}
                                            limit={limit}
                                            onPageChange={p => fetchOrphans(p, searchTerm)}
                                        />
                                    </>
                                ) : (
                                    <NoData>No data found</NoData>
                                )}
                            </Tab>
                        </Tabs>
                    </Body>
                </div>
            </Container>
        )
    }, [dashboards, orphans, page, searchTerm, isLoading])
}

export default AdnocAdminPage

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const Body = styled.div`
    display: flex;
    margin-top: 55px;
    height: 100%;
    padding: 8px 60px;
    flex-direction: column;
`
const NoData = styled.div`
    color: #999;
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
`
const Loading = styled.div`
    color: #999;
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
`
